import React from 'react';
import './ReputationSystemModal.scss';
import './QualityModal.scss';
import classNames from 'classnames';
import closeButton from '../../../../components/images/close-button.svg';

import terribleEmoji from '../../../../components/images/emojis/terrible@3x.png';
import notGreatEmoji from '../../../../components/images/emojis/not-great@3x.png';
import decentEmoji from '../../../../components/images/emojis/decent@3x.png';
import goodEmoji from '../../../../components/images/emojis/good@3x.png';
import exceptionalEmoji from '../../../../components/images/emojis/exceptional@3x.png';


class QualityModal extends React.Component {
  constructor(props) {
    super(props);
    this.props = props;
    const { content } = this.props;
    this.state = {
      comments: content && content.comments ? content.comments : '',
      commentsError: false,
      rating: content && content.rating ? content.rating : false,
      ratingError: false,
    };

    this.NEUTRAL_VALUE = 3;
  }

  handleSelect = (option) => {
    const { label, value } = option;
    let { commentsError } = this.state;

    if (value === this.NEUTRAL_VALUE) commentsError = false;

    this.setState({
      rating: {
        label,
        value,
      },
      commentsError,
    });
  }

  onChange(event) {
    this.handleSelect(event.target.value);
  }

  handleCommentsChange = (event) => {
    this.setState({
      comments: event.target.value,
    });
  }

  validate = () => {
    const { comments, rating } = this.state;

    let commentsError = false;
    let ratingError = false;

    if (comments === '' && (rating.value && rating.value !== this.NEUTRAL_VALUE)) commentsError = true; // Comments required unless response is neutral
    if (!rating.value) ratingError = true;

    if (commentsError || ratingError) {
      this.setState({
        commentsError,
        ratingError,
      });
    } else {
      this.props.onNext(comments, rating);
    }
  }

  render() {
    const { isEditing, username } = this.props;
    const {
      comments, commentsError, rating, ratingError,
    } = this.state;
    const options = [
      { label: 'terrible', value: 1, img: terribleEmoji },
      { label: 'not great', value: 2, img: notGreatEmoji },
      { label: 'decent', value: 3, img: decentEmoji },
      { label: 'good', value: 4, img: goodEmoji },
      { label: 'exceptional', value: 5, img: exceptionalEmoji },
    ];

    return (
      <React.Fragment>
        <div className="NoizModalOverlay" />
        <div className="ReputationModal">
          { isEditing ? (<img alt="close-button" className="close" src={closeButton} onClick={this.props.onClose.bind(this)} />) : null }
          <h2> How would you rate the quality of <span className="username">{username}</span>'s stream? </h2>
          <div className="optionsList quality">
            { options.map(opt => (
              <span onClick={this.handleSelect.bind(this, opt)} className={classNames('option', { selected: rating.value === opt.value })}>
                <img className="emoji" alt={opt.label} src={opt.img} />
                { opt.label }
              </span>
              )) }
          </div>
          { ratingError && (<span className="error">Rating required</span>) }

          <span className="label">Comments</span>
          <textarea name="comments" id="comments" value={comments} onChange={this.handleCommentsChange} />
          <span className="note">*Note: influencer will not see this rating or comment</span>
          { commentsError && (<span className="error">Comments required</span>) }

          <div className="buttons quality">
            <button className="CTAButton__purple" onClick={this.validate.bind(this)}> Next </button>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

QualityModal.propTypes = {
};

export default QualityModal;
